import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=9d9dae74&scoped=true"
import script from "./Translations.vue?vue&type=script&lang=ts"
export * from "./Translations.vue?vue&type=script&lang=ts"
import style0 from "./Translations.vue?vue&type=style&index=0&id=9d9dae74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9dae74",
  null
  
)

export default component.exports